// extracted by mini-css-extract-plugin
module.exports = {"stat":"StatsOverview_stat__21iNf","horizontal":"StatsOverview_horizontal__3afh6"};